/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent} from 'react';
import Menu from '@material-ui/core/Menu';
import {makeStyles} from '@material-ui/core/styles';
import {dlsColor, dlsZIndex} from '../../theme/theme';
import DropdownItem from './DropdownItem';

export interface SingleSelectMenuProps {
  items?: {
    title: string;
    handleClick: (event: MouseEvent<HTMLLIElement>) => void;
    selected: boolean;
  }[];
  menuOpen: boolean;
  anchorEl: null | HTMLElement;
  onMenuClose?: () => void;
}

const useStyles = makeStyles(theme => ({
  menuListItem : {
    '&:nth-of-type(3)' : {
      borderBottom : `solid 1px ${dlsColor('grey5')}`
    }
  },
  notificationMenuPaper : {
    marginTop : '35px'
  },
  notificationMenuList : {
    padding : '0'
  },
  notificationPopover : {
    '&&' : {
      zIndex : `${dlsZIndex('singleSelectMenuNotificationPopover')} !important`
    }
  }
}));

const SingleSelectMenu = ({
  items = [],
  menuOpen,
  onMenuClose,
  anchorEl
}: SingleSelectMenuProps) => {
  const classes = useStyles();
  return (
    <Menu open={menuOpen}
      classes={{
        paper : classes.notificationMenuPaper,
        list  : classes.notificationMenuList
      }}
      PopoverClasses={{
        root : classes.notificationPopover
      }}
      elevation={4}
      keepMounted
      anchorEl={anchorEl}
      onClose={onMenuClose}>
      {
        items.map((item, index) => {
          return (
            <div key={`single-select-menu-item-${index}`} className={classes.menuListItem}>
              <DropdownItem text={item.title}
                onClick={item.handleClick}
                checked={item?.selected} />
            </div>
          );
        })
      }
    </Menu>
  );
};

export default SingleSelectMenu;
